/** @format */

export default function unixTime(time:Date) {
  return time
    ? Math.floor(new Date(time).getTime() / 1000)
    : Math.floor(new Date().getTime() / 1000);
}
